const isSandbox = () => window.location.hostname.includes("sandbox");

const getLoginUrl = () =>
  isSandbox()
    ? "https://login.sandbox.altruon.io/sign-in"
    : "https://login.altruon.io/sign-in";

const DomainNotRegisteredPage = () => {
  const tenantId = window.location.hostname.split(".")[0];

  return (
    <div style={styles.page}>
      <style>{cssString}</style>

      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h1 style={styles.heading}>Domain not found</h1>
        <p style={styles.sub}>
          <span style={styles.domainChip}>{tenantId}</span> isn't registered with Altruon.
        </p>
        <p style={styles.hint}>
          If you believe this is a mistake, please reach out to{" "}
          <a href="mailto:support@altruon.io" style={styles.link}>support@altruon.io</a>.
        </p>

        <a
          href={getLoginUrl()}
          style={styles.button}
          className="altruon-login-btn"
        >
          Go to Login
        </a>

        {isSandbox() && (
          <span style={styles.envBadge}>Sandbox</span>
        )}
      </div>

      <p style={styles.footer}>
        © {new Date().getFullYear()} Altruon
      </p>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8fafc",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif",
    padding: "24px",
    gap: "24px",
  },
  card: {
    position: "relative",
    maxWidth: "400px",
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
    padding: "40px 36px 36px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
  },
  iconWrap: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "4px",
  },
  heading: {
    fontSize: "22px",
    fontWeight: "600",
    color: "#0f172a",
    margin: "0",
    letterSpacing: "-0.3px",
  },
  sub: {
    fontSize: "14px",
    color: "#64748b",
    margin: "0",
    lineHeight: "1.6",
  },
  domainChip: {
    display: "inline-block",
    backgroundColor: "#f1f5f9",
    color: "#334155",
    fontWeight: "600",
    fontSize: "13px",
    padding: "2px 8px",
    borderRadius: "6px",
    fontFamily: "monospace",
  },
  hint: {
    fontSize: "13px",
    color: "#94a3b8",
    margin: "0",
    lineHeight: "1.6",
  },
  link: {
    color: "#6366f1",
    textDecoration: "none",
  },
  button: {
    display: "block",
    width: "100%",
    marginTop: "8px",
    padding: "11px 0",
    backgroundColor: "#0f172a",
    color: "#ffffff",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "500",
    textDecoration: "none",
    letterSpacing: "0.1px",
    transition: "background-color 0.15s ease, transform 0.1s ease",
    boxSizing: "border-box",
    cursor: "pointer",
  },
  envBadge: {
    display: "inline-block",
    backgroundColor: "#fef9c3",
    color: "#854d0e",
    fontSize: "11px",
    fontWeight: "600",
    padding: "3px 10px",
    borderRadius: "20px",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
  },
  footer: {
    fontSize: "12px",
    color: "#cbd5e1",
    margin: "0",
  },
};

const cssString = `
  .altruon-login-btn:hover {
    background-color: #1e293b !important;
    transform: translateY(-1px);
  }
  .altruon-login-btn:active {
    transform: translateY(0);
  }
`;

export default DomainNotRegisteredPage;